import { ENTER, COMMA } from '@angular/cdk/keycodes';
import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  OnInit,
  QueryList,
  ViewChild,
  ViewChildren,
} from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { MatChipInputEvent } from '@angular/material/chips';
import { ModalController } from '@ionic/angular';
import { DialogUtility } from '@syncfusion/ej2-angular-popups';
import { Subscription } from 'rxjs/internal/Subscription';
import { User } from 'src/app/models/user.model';
import { ApiService } from 'src/app/services/api.service';
import { FileViewerService } from 'src/app/services/fileviewer.service';
import { OilEventComponent } from '../oil-event/oil-event.component';
import { interval, Subject } from 'rxjs';
import { startWith, switchMap, takeUntil, tap } from 'rxjs/operators';

@Component({
  selector: 'event-item',
  templateUrl: './event-item.component.html',
  styleUrls: ['./event-item.component.scss'],
})
export class EventItemComponent implements OnInit {
  public isSaving = false;
  @Input() type: 'View' | 'Edit' | 'Add';
  @Input() eventId: any;
  @Input() assetObj: any;
  @Input() item: any = null;
  @Input() documentId?: any = null;
  @Input() taskListId?: any = null;
  @Input() assetMaintenanceMappingId?: any = null;
  @Input() taskListType?: any = null;
  @Input() isScreenSplit?: any = false;
  @Input() documentType?: any = 'General';
  isDocument: boolean = false;
  @ViewChildren('userTooltipRef') userTooltipRef: QueryList<any>;
  @ViewChildren('userTooltipRef2') userTooltipRef2: QueryList<any>;
  @ViewChild('fileInput') fileInput!: ElementRef<HTMLInputElement>;
  @ViewChild('fileInput2') fileInput2!: ElementRef<HTMLInputElement>;
  @ViewChild('commentsContainer') commentsContainer!: ElementRef;

  @ViewChild('replyFileInput') replyFileInput!: ElementRef<HTMLInputElement>;

  closedBy: string = '';
  comments: Object[] = [];
  comment: string = '';
  reply: string = '';
  updateCommentValue: string = '';
  replyAttachments: { file: File; preview?: string; isImage: boolean }[] = [];
  attachments: { file: File; preview?: string; isImage: boolean }[] = [];
  attachmentsForUpdateComment: { file: File; preview?: string; isImage: boolean }[] = [];
  savedAttachmentsLists: any = [];
  categories: any = ['Documents', 'Maintenance Status', 'Physical Inspection', 'Miscellaneous'];
  documentTypes: any = [];
  status: any = ['OPEN', 'CLOSED'];
  oilEventItemsForm: FormGroup;
  alreadyAssignedUser: any[] = []; // stores only IDs
  filteredItems: any;
  assetDocLists: any[];
  awdbSub: Subscription;
  sub: Subscription;
  userSub: Subscription;
  openedThreadId: number | null = null;
  // selectedUsers: any[] = [];
  users: any[] = [];
  // filteredUsersList: any[] = [];
  searchedUserLoading: boolean = false;
  // separatorKeysCodes: number[] = [ENTER, COMMA];
  selectedAssetDocumentObj: any;
  oilEventItemsCommentsList: any[] = [];
  oilEventItemsThreadsList: any[] = [];
  oilEventItemActivityLogs: any[] = [];

  oilEventItemThreadsList: any[] = [];
  physicalInspectionList: any[] = [];
  selectedEventItemsCommentObj: any;
  clientID = localStorage.getItem('client') ? JSON.parse(localStorage.getItem('client'))?.clientID : null;
  oilEventItemAttachmentListObj: any;
  taskIdLoadingDataLength: boolean = false;
  oilEvents: any[];
  approval: string | null = null;
  approvalComment: string = '';
  public isLoading: boolean = false;
  private destroy$ = new Subject<void>();

  itemUsers: any[] = [];

  tempReplyText?: string;
  tempEditText?: string;

  public mentionTarget = '#mentionElement';
  public editMentionTarget = '#editMentionElement';
  public editMentionTargetSingle = '#editMentionElementSingle';
  public replyMentionTarget = '#replyMentionElement';
  public fields = { text: 'userName', value: 'id' };
  public displayTemplate = '<span contenteditable="false" class="e-mention-chip" data-id="${id}">${userName}</span>';

  constructor(
    private modalController: ModalController,
    private apiService: ApiService,
    public fileViewService: FileViewerService,
    private cdr: ChangeDetectorRef
  ) { }

  get oilEventItemsRootThreadsList() {
    return this.oilEventItemsThreadsList.filter((t) => t.threadId === null && t.parentId === null);
  }

  ngOnInit() {
    // if (this.type === 'Add') {
    //   this.sno = 'Serial No Here';
    //   this.details = '';
    // }
    // if (this.type === 'Edit') {
    //   this.sno = this.item.sno;
    //   this.details = this.item.details;
    //   this.attachments = this.item.attachments;
    //   console.log('itm', this.item);
    // }
    // if (this.type === 'View') {
    //   this.sno = this.item.sno;
    //   this.details = this.item.details;
    //   this.comments = this.item.comments;
    //   this.attachments = this.item.attachments;
    // }

    this.oilEventItemsForm = new FormGroup({
      eventId: new FormControl(this.eventId),
      title: new FormControl(null),
      category: new FormControl(null, [Validators.required]),
      physicalSection: new FormControl(null),
      description: new FormControl(null),
      documentType: new FormControl(null),
      assetDocId: new FormControl(null),
      createdAt: new FormControl(new Date()),
      users: new FormControl([]),
      status: new FormControl('OPEN'),
    });

    if (this.documentId !== null) {
      if (this.eventId === null) {
        this.getOilEventDashboardData();
      }
      this.isDocument = true;
      if (this.isDocument && (this.documentType === 'AD' || this.documentType === 'MPD' || this.documentType === 'SBMOD' || this.documentType === 'Repair Damage')) {
        this.documentTypes = ['AD', 'MPD', 'SBMOD', 'Repair Damage']
        this.oilEventItemsForm.patchValue({
          category: 'Maintenance Status',
          documentType: this.documentType,
        });
      } else {
        this.documentTypes = ['General']
        this.oilEventItemsForm.patchValue({
          category: 'Documents',
          documentType: this.documentType,
        });
      }

      this.getAssetDocList({ name: 'id', value: this.documentId });
    }
    if (this.taskListId !== null) {
      if (this.eventId === null) {
        this.getOilEventDashboardData();
      }
      this.isDocument = false
      this.documentTypes = ['AD', 'MPD', 'SBMOD', 'Repair Damage']
      this.oilEventItemsForm.patchValue({
        category: 'Maintenance Status',
        documentType: this.taskListType,
      });
      this.getData({ name: 'id', value: this.taskListId });

    }

    this.getUsers();

    if (this.item !== null) {
      this.setForm();
    }

    if (this.type === 'View') {
      interval(40000)
        .pipe(
          startWith(0), // run immediately
          tap(() => {
            this.getEventItemsAttachment();
            this.getEventItemsThread();
            this.getEventItemActivityLogs();
            this.getEventItemThreadsList();
            this.itemUsers = this.item?.users;
          }),
          takeUntil(this.destroy$)
        )
        .subscribe({
          next: () => { },
          error: (err) => console.error('Polling error:', err),
        });
    }

  }

  // 🔎 Extract text + mention list
  extractMentionData(id) {
    const mentionEl = document.getElementById(id);

    // const text = mentionEl?.innerText?.trim() ?? '';
    const text = mentionEl?.innerHTML;

    const mentionChips = mentionEl?.querySelectorAll('.e-mention-chip') ?? [];

    const mentions: any[] = [];

    mentionChips.forEach((chip: any) => {
      if (chip.getAttribute('data-id')) {
        mentions.push({
          id: chip.getAttribute('data-id'),
          display: chip.innerText.replace('@', ''),
        });
      }
    });

    return { text, mentions };
  }

  closeThread(t) {
    this.oilEventItemsThreadsList = this.oilEventItemsThreadsList.map((thread) => {
      if (thread.id === t.id) {
        this.openedThreadId = null;
        thread.open = false;
      }
      return thread;
    });
  }

  onApprovalChange(event: any) {
    this.approval = event.value;
    this.approvalComment = '';
    if (event.value === 'APPROVED_WITH_EXCEPTION') {
      this.apiService.logPageFormStep.next(null);
    }
    else if (this.type !== 'View') {
      this.apiService.logPageFormStep.next(2);
    }
  }

  onApprovalCommentChange(event: any) {
    this.approvalComment = event.target.value;
  }

  public openThread = (t) => {
    this.oilEventItemsThreadsList = this.oilEventItemsThreadsList.map((thread) => {
      if (thread.id === t.id) {
        this.openedThreadId = t.id;
        thread.open = true;
      } else {
        thread.open = false;
      }
      return thread;
    });
    const comment = this.oilEventItemsThreadsList
      .filter((thread) => thread.threadId === t.id || thread.id === t.id)
      .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))[0];
    if (comment) {
      setTimeout(() => {
        const container = this.commentsContainer.nativeElement;
        const target = document.getElementById(comment.id.toString());

        if (!container || !target) return;

        const offset = target.offsetTop - container.offsetTop;

        container.scrollTo({
          top: offset,
          behavior: 'smooth',
        });
      }, 1);
    }
    this.cdr.detectChanges();
  };

  public setForm(): void {
    if (this.item) {
      this.oilEventItemsForm = new FormGroup({
        eventId: new FormControl(this.eventId),
        title: new FormControl(this.item?.title),
        category: new FormControl(this.item?.category, [Validators.required]),
        physicalSection: new FormControl(this.item?.physicalSection),
        description: new FormControl(this.item?.description),
        documentType: new FormControl(this.item?.documentType),
        createdAt: new FormControl(this.item?.createdAt),
        assetDocId: new FormControl(null),
        users: new FormControl([]),
        status: new FormControl(this.item.status),
      });
      if (this.item.approval) {
        this.approval = this.item.approval.approvalStatus;
        if (this.item.approval.approvalStatus === "APPROVED_WITH_EXCEPTION") {
          this.approvalComment = this.item.approval.comment;
        }
      }
      if (this.item?.category === 'Documents') {
        this.isDocument = true
        this.documentTypes = ['General']
        this.oilEventItemsForm.patchValue({
          documentType: this.item?.documentType,
        });
        this.getAssetDocList({ name: 'id', value: this.item?.assetDocId });
        if (this.type !== 'View') {
          this.apiService.logPageFormStep.next(2);
        }
      } else if (this.item?.category === 'Physical Inspection') {
        if (this.type !== 'View') {
          this.apiService.logPageFormStep.next(1);
        }
        this.getPhysicalInstpectionData();
      }
      else if (this.item?.category === 'Maintenance Status') {
        this.taskListId = this.item?.assetMaintenanceMappingId
        this.documentTypes = ['AD', 'MPD', 'SBMOD', 'Repair Damage']
        this.taskListType = this.item?.taskListType
        console.log(this.item)
        this.oilEventItemsForm.patchValue({
          documentType: this.taskListType,
        });
        if (this.item?.assetMaintenanceMappingId && (this.taskListType === 'AD' || this.taskListType === 'MPD' || this.taskListType === 'SBMOD' || this.taskListType === 'Repair Damage')) {
          this.isDocument = false
          this.getData({ name: 'assetMaintenanceMappingId', value: this.item?.assetMaintenanceMappingId });
        } else {
          this.isDocument = true
          this.getAssetDocList({ name: 'id', value: this.item?.assetDocId });
        }
        if (this.type !== 'View') {
        this.apiService.logPageFormStep.next(2);
        }
      }
      else if (this.type !== 'View') {
        this.apiService.logPageFormStep.next(1);
      }
      if (this.type === 'Edit') {
        this.getEventItemsAttachment();
      }
      // if (this.type === 'View') {
      //   this.getEventItemsThread();
      //   this.getEventItemActivityLogs();
      //   this.getEventItemThreadsList();
      //   this.itemUsers = this.item.users;
      //   console.log('item ');
      // }
    }
  }

  closeDialog() {
    this.modalController.dismiss({
      dismissed: false,
    });
  }

  public ngOnDestroy(): void {
    this.openedThreadId = null;
    this.destroy$.next();
    this.destroy$.complete();
  }
  searchValue: any;
  onInputChange(event: any): void {
    this.searchValue = event?.target?.value?.toLowerCase()?.trim() || '';
    if (this.filteredItems?.length === 0) {
      this.taskIdLoadingDataLength = true;
    }
  }

  displayFn = (id: number): string => {
    const item = this.assetDocLists?.find((p) => p.id === id);
    return item ? item.fullPathWithFileName : '';
  };

  public getData(filter): void {
    try {
      const params = {
        page: 1,
        limit: 10000000,
        filter
      };
      let assetTypeId =
        this.assetObj?.assetTypeId?.toString() === '1' ? 10 :
          this.assetObj?.assetTypeId?.toString() === '2' ? 11 :
            this.assetObj?.assetTypeId?.toString() === '3' ? 12 :
              this.assetObj?.assetTypeId?.toString() === '4' ? 14 :
                this.assetObj?.assetTypeId?.toString() === '5' ? 13 :
                  this.assetObj?.assetTypeId?.toString() === '6' ? 15 :
                    this.assetObj?.assetTypeId
      switch (this.taskListType) {
        case 'AD':
          this.awdbSub = this.apiService.getAirWorthinessDirectivesByAssets(params, this.assetObj?.assetId, assetTypeId).subscribe((res: any) => {
            this.assetDocLists = res?.data || [];
            this.filteredItems = this.assetDocLists; // Initially show all
            if (this.item?.assetMaintenanceMappingId || this.assetMaintenanceMappingId) {
              this.oilEventItemsForm.patchValue({
                assetDocId: this.item?.assetMaintenanceMappingId || this.assetMaintenanceMappingId,
              });
            }
            this.isLoading = false
          }, (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

          }), (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
          };
          break;
        case 'MPD':
          this.awdbSub = this.apiService.getMpdByAssets(params, this.assetObj?.assetId, assetTypeId).subscribe((res: any) => {
            this.assetDocLists = res?.data || [];
            this.filteredItems = this.assetDocLists; // Initially show all
            if (this.item?.assetMaintenanceMappingId || this.assetMaintenanceMappingId) {
              this.oilEventItemsForm.patchValue({
                assetDocId: this.item?.assetMaintenanceMappingId || this.assetMaintenanceMappingId,
              });
            }
            this.isLoading = false
          }, (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

          }), (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
          };
          break;
        case 'Repair Damage':
          this.awdbSub = this.apiService.getRepairDamageByAssets(params, this.assetObj?.assetId, assetTypeId).subscribe((res: any) => {
            this.assetDocLists = res?.data || [];
            this.filteredItems = this.assetDocLists; // Initially show all
            if (this.item?.assetMaintenanceMappingId || this.assetMaintenanceMappingId) {
              this.oilEventItemsForm.patchValue({
                assetDocId: this.item?.assetMaintenanceMappingId || this.assetMaintenanceMappingId,
              });
            }
            this.isLoading = false
          }, (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

          }), (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
          };
          break;
        case 'SBMOD':
          this.awdbSub = this.apiService.getSbModByAssets(params, this.assetObj?.assetId, assetTypeId).subscribe((res: any) => {
            this.assetDocLists = res?.data || [];
            this.filteredItems = this.assetDocLists; // Initially show all
            if (this.item?.assetMaintenanceMappingId || this.assetMaintenanceMappingId) {
              this.oilEventItemsForm.patchValue({
                assetDocId: this.item?.assetMaintenanceMappingId || this.assetMaintenanceMappingId,
              });
            }
            this.isLoading = false
          }, (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)

          }), (err: any) => {
            this.isLoading = false
            this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
          };
          break;
      }

    } catch (err) {
      this.isLoading = false
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null)
    }
  }

  async getAssetDocList(filter: any) {
    if (!this.oilEventItemsForm.get('documentType').value) {
      this.apiService.openErrorSnackBar('Please Select Document Type');
      return
    }
    try {
      let obj = {
        // assetTypeId: this.assetObj?.assetTypeId,
        // assetId: this.assetObj?.assetId,
        eventId: this.eventId,
        type: this.oilEventItemsForm.get('documentType').value,
        filter,
      };
      this.oilEventItemsForm.controls.assetDocId.setValue(null);
      const response = await this.apiService
        .getAssetsDocListApi(obj)
        .toPromise()
        .catch((err) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        });
      if (response?.error?.error) {
        this.apiService.openErrorSnackBar(
          response?.error?.error ? response?.error?.error : 'Please contact support team',
          null
        );
        throw new Error(response?.error?.error?.message);
      }
      this.assetDocLists = Object.values(response?.body || []);
      this.filteredItems = this.assetDocLists; // Initially show all
      if (this.item || this.documentId) {
        this.oilEventItemsForm.patchValue({
          assetDocId: this.item?.assetDocId || this.documentId,
        });
        this.getAssetDocumentObj();
      }

      // this.openSnackBar("SUCCESS", null);
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }

  flattenThread(items) {
    const result = [];

    function recurse(list) {
      for (const item of list) {
        result.push({
          ...item, updatedAt: new Date(item.updatedAt).toLocaleString('en-GB', {
            day: '2-digit',
            month: 'short',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            hour12: false,
          }), replies: undefined
        }); // remove replies if you want clean flat output
        if (item.replies && item.replies.length > 0) {
          recurse(item.replies);
        }
      }
    }

    recurse(items);
    return result;
  }

  flattenThreadsReplies(threads) {
    function getFlatReplies(replies) {
      const result = [];

      function recurse(list) {
        for (const item of list) {
          // Push the item without its nested replies
          const { replies, ...rest } = item;
          result.push(rest);

          // Recursively collect nested replies
          if (replies && replies.length > 0) {
            recurse(replies);
          }
        }
      }

      recurse(replies);
      return result;
    }

    return threads.map((thread) => {
      return {
        ...thread,
        replies: getFlatReplies(thread.replies ?? []),
      };
    });
  }

  getDocuments() {
    if (this.searchValue) {
      if (this.documentId === null) {
        this.getAssetDocList({ name: 'filenameFilter', value: this.searchValue });
      }
    }
  }
  documentTypeSelected(args: any) {
    if (this.oilEventItemsForm.get('category').value === 'Maintenance Status') {
      this.isDocument = false
      this.taskListType = args.value
    }
    this.filteredItems = [];
    this.assetDocLists = [];
    this.oilEventItemsForm.patchValue({
      assetDocId: null,
    });
  }

  formatUserDisplay(user: any): string {
    if (!user) return '';
    // let parts = ['User Name: ' + user?.firstName + ' ' + user?.lastName, '|| Email:' + user?.email];
    let parts = [user?.firstName + ' ' + user?.lastName];
    return parts.join(' ');
  }

  public async addEditEvent(args?: any): Promise<void> {
    const modal = await this.modalController.create({
      component: OilEventComponent,
      cssClass: 'add-Edit-Event',
      componentProps: { type: args ? 'Edit' : 'Add', event: args || null, assetObj: this.assetObj },
    });
    await new Promise((resolve) => setTimeout(resolve, 30));

    // Locate modal element
    const modalEl = document.querySelector('ion-modal:last-of-type') as HTMLElement | null;

    if (modalEl) {
      // Determine base z-index
      const baseZ = this.getHighestZIndexExcluding(modalEl);
      const backdropZ = baseZ + 1;
      const modalZ = baseZ + 2;

      // Create custom backdrop
      const backdrop = document.createElement('div');
      backdrop.className = 'custom-nested-backdrop';
      Object.assign(backdrop.style, {
        position: 'fixed',
        inset: '0',
        background: 'rgba(0,0,0,0.45)',
        backdropFilter: 'blur(2px)',
        zIndex: String(backdropZ),
        pointerEvents: 'auto',
      });

      // Insert backdrop right before modal
      modalEl.parentNode?.insertBefore(backdrop, modalEl);

      // Raise modal z-index
      modalEl.style.setProperty('z-index', String(modalZ), 'important');
      const inner = modalEl.shadowRoot?.querySelector('.modal-wrapper') || modalEl.querySelector('.modal-wrapper');
      if (inner) (inner as HTMLElement).style.setProperty('z-index', String(modalZ), 'important');

      // Hide Ionic’s default backdrop if any
      const ionBackdrop = modalEl.shadowRoot?.querySelector('ion-backdrop') || modalEl.querySelector('ion-backdrop');
      if (ionBackdrop) (ionBackdrop as HTMLElement).style.display = 'none';

      // Prevent scroll
      document.body.style.overflow = 'hidden';
      await modal.present();
      modal.onDidDismiss().then((result) => {
        if (result.data && result.data.dismissed) {
          this.getOilEventDashboardData();
          // Refresh document list or perform another action
        }
        backdrop.remove();
        document.body.style.overflow = '';
      });
    }
  }

  /** Return the highest numeric z-index in the document excluding optional element */
  private getHighestZIndexExcluding(excludeEl?: Element | null): number {
    const nodes = Array.from(document.querySelectorAll('body *')) as HTMLElement[];
    let max = 1000;
    for (const el of nodes) {
      if (!el.offsetParent) continue; // skip hidden elements
      if (excludeEl && (excludeEl === el || excludeEl.contains(el))) continue;
      const z = window.getComputedStyle(el).zIndex;
      const zi = parseInt(String(z), 10);
      if (!Number.isNaN(zi)) max = Math.max(max, zi);
    }
    return max;
  }

  public getOilEventDashboardData(): void {
    this.oilEvents = null;
    try {
      (this.awdbSub = this.apiService.getOilEventDashboardFilteredData(this.assetObj).subscribe(
        (res: any) => {
          this.oilEvents = res?.data?.length > 0 ? res?.data : [];
          this.isLoading = false;
        },
        (err) => {
          this.isLoading = false;
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      )),
        (err) => {
          this.isLoading = false;
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.isLoading = false;
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }
  public getUsers(): void {
    // let data = {
    //   userId: 'all',
    //   clientID: this.clientID,
    //   // filter,
    // };
    this.users = [];
    const id = this.eventId || this.oilEventItemsForm.get('eventId').value;
    this.searchedUserLoading = true;
    this.userSub = this.apiService.getEventUsersListByEventId(id).subscribe(
      (res: any) => {
        this.users = res?.users?.length > 0 ? res?.users : [];
        if (this.item) {
          const assignedUserIds = this.item?.users?.map((ua: any) => ua?.id);
          this.oilEventItemsForm.get('users')?.setValue(assignedUserIds);
        }
        this.searchedUserLoading = false;
      },
      (err) => {
        this.searchedUserLoading = false;
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      }
    );
    (err) => {
      this.searchedUserLoading = false;
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    };
  }
  // selected(event: MatAutocompleteSelectedEvent): void {
  //   const user = event.option.value;
  //   if (!this.selectedUsers.some((r) => r?.id === user?.id)) {
  //     this.selectedUsers.push({ eventSavedDBUsers: false, ...user });
  //     const userIds = this.selectedUsers.map((r) => r?.id);
  //     this.oilEventItemsForm.get('users')?.setValue(userIds);
  //   }

  //   // this.autoInput.nativeElement.value = '';
  //   const selectedFilteredAssetsList = this.users.filter(
  //     (allUser) => !this.selectedUsers.some((selectedUser) => selectedUser?.id === allUser?.id)
  //   );
  //   this.filteredUsersList = selectedFilteredAssetsList;

  //   this.userTooltipRef.forEach((tooltip) => {
  //     tooltip.close(); // Or tooltip.hide() depending on ejs-tooltip API
  //   });
  // }
  // userSearchedVlaue: any = '';
  // getSearchedUsers() {
  //   if (this.userSearchedVlaue) {
  //     this.getUsers({ name: 'filter', value: this.userSearchedVlaue });
  //   }
  // }
  // add(event: MatChipInputEvent): void {
  //   const value = (event?.value || '').trim();
  //   // Add the value only if it's not empty
  //   if (value) {
  //     const existing = this.users.find((user) => user?.id === value);
  //     if (existing && !this.selectedUsers.includes(existing)) {
  //       this.selectedUsers.push({ eventSavedDBUsers: false, ...existing });
  //     }
  //   }

  //   // Clear the input value
  //   event.chipInput!.clear();

  //   // Update the form control (optional)
  // }

  // onInputUserChange(event: any): void {
  //   this.userSearchedVlaue = event?.target?.value?.toLowerCase() || '';
  //   // this.filteredItems = this.taskIdList.filter((item) => this.getItemLabel(item).toLowerCase().includes(searchValue));
  // }
  // removeRole(user: any): void {
  //   const index = this.selectedUsers.indexOf(user);
  //   if (index >= 0) {
  //     this.selectedUsers.splice(index, 1);
  //   }
  //   const assetRoleIds = this.selectedUsers.map((r) => r?.id);
  //   this.oilEventItemsForm.get('users')?.setValue(assetRoleIds);
  //   this.filteredUsersList = this.users.filter(
  //     (allUsers) => !this.selectedUsers.some((selectedAssets) => selectedAssets?.id === allUsers?.id)
  //   );
  // }
  public submit(): void {
    if (this.oilEventItemsForm.invalid) {
      this.oilEventItemsForm.markAllAsTouched();
      return;
    }

    this.isSaving = true;
    this.EventApiCall();
  }

  public EventApiCall(): void {
    try {
      var obj: any;
      obj = {
        eventId: this.eventId || this.eventId || this.oilEventItemsForm.get('eventId').value,
        title: this.oilEventItemsForm.get('title')?.value,
        category: this.oilEventItemsForm.get('category').value,
        description: this.oilEventItemsForm.get('description')?.value,
        assignedUsers: this.oilEventItemsForm.get('users')?.value,
        status: this.oilEventItemsForm.get('status')?.value,
        createdAt: this.oilEventItemsForm.get('createdAt')?.value,
      };
      let category = this.oilEventItemsForm.get('category').value;
      if (category === 'Documents') {
        obj['documentType'] = this.oilEventItemsForm.get('documentType')?.value;
        obj['assetDocId'] = this.oilEventItemsForm.get('assetDocId')?.value;
        obj['documentCategory'] = this.selectedAssetDocumentObj?.rootFolderName || '';
        obj['approvalStatus'] = this.approval;
        obj['approvalComment'] = this.approvalComment;
      } else if (category === 'Physical Inspection') {
        obj['physicalSection'] = this.oilEventItemsForm.get('physicalSection')?.value;
      }
      else if (category === 'Maintenance Status') {
        obj['taskListType'] = this.oilEventItemsForm.get('documentType')?.value;
        if(this.item){
          obj['approvalStatus'] = this.approval;
          obj['approvalComment'] = this.approvalComment;
        }
        if (this.isDocument) {
          obj['assetDocId'] = this.oilEventItemsForm.get('assetDocId')?.value;
        } else {
          obj['assetMaintenanceMappingId'] = this.oilEventItemsForm.get('assetDocId')?.value;
        }
      }
      // if create for status list
      if (this.item === null) {
        let data = {
          recordObj: obj,
        };
        (this.sub = this.apiService.addEventItems(data).subscribe(
          (res: any) => {
            if (res !== null) {
              this.apiService.openSnackBar('Data Created Successfully');
              this.oilEventItemsForm.reset();
              this.modalController.dismiss({
                dismissed: true,
              });
              this.isSaving = false;
            }
          },
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          }
        )),
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          };
      }
      // update for status list
      else {
        obj['id'] = Number(this.item?.id);
        let data = {
          recordObj: obj,
        };
        const formData = new FormData();
        if (this.attachments?.length > 0) {
          formData.append('itemId', this.item?.id);
          this.attachments.forEach((res) => {
            formData.append('attachments[]', res?.file);
          });
          (this.sub = this.apiService.addEventItemsCommentAttachment(formData).subscribe(
            (res: any) => {
              this.attachments = [];
              this.fileInput.nativeElement.value = '';
            },
            (err: any) => {
              this.isSaving = false;
              this.attachments = [];
              this.fileInput.nativeElement.value = '';
              this.apiService.openErrorSnackBar(
                err?.error?.error ? err?.error?.error : 'Please contact support team',
                null
              );
              return;
            }
          )),
            (err: any) => {
              this.isSaving = false;
              this.attachments = [];
              this.fileInput.nativeElement.value = '';
              this.apiService.openErrorSnackBar(
                err?.error?.error ? err?.error?.error : 'Please contact support team',
                null
              );
              return;
            };
        }
        (this.sub = this.apiService.updateEventItems(data).subscribe(
          (res: any) => {
            if (res !== null) {
              this.apiService.openSnackBar('Data Updated Successfully');
              this.oilEventItemsForm.reset();
              this.modalController.dismiss({
                dismissed: true,
              });
            }

            this.isSaving = false;
          },
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          }
        )),
          (err: any) => {
            this.isSaving = false;
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          };
      }
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }
  getAssetDocumentObj() {
    const selectedId = this.oilEventItemsForm.get('assetDocId')?.value;
    this.selectedAssetDocumentObj = this.filteredItems.find((e) => e.id === selectedId) || null;
    this.userTooltipRef2.forEach((tooltip) => {
      tooltip.close(); // Or tooltip.hide() depending on ejs-tooltip API
    });
  }

  categoryValueChange() {
    if (this.oilEventItemsForm.get('category').value === 'Maintenance Status') {
      this.isDocument = false
      this.documentTypes = ['AD', 'MPD', 'SBMOD', 'Repair Damage']
      this.oilEventItemsForm.get('documentType').setValue(null);
    } else {
      this.isDocument = true
      this.documentTypes = ['General']
      this.oilEventItemsForm.get('documentType').setValue('General');
    }
    this.oilEventItemsForm.get('assetDocId').setValue(null);
    this.selectedAssetDocumentObj = null;
    this.oilEventItemsForm.get('physicalSection').setValue(null);
    this.approval = null;
    this.approvalComment = '';
    // if (this.oilEventItemsForm.get('category').value === 'Documents') {
    //   this.documentTypeSelected();
    // } else
    if (this.oilEventItemsForm.get('category').value === 'Physical Inspection') {
      this.getPhysicalInstpectionData();
    }
    if (this.type !== 'View' && (this.oilEventItemsForm.get('category').value === 'Documents' || this.oilEventItemsForm.get('category').value === 'Maintenance Status')) {
      this.apiService.logPageFormStep.next(2);
    } else if (this.type !== 'View') {
      this.apiService.logPageFormStep.next(1);
    }
  }

  public addReply() {
    const { text, mentions } = this.extractMentionData('replyMentionElement');

    this.reply = text;
    if (!this.reply || !this.reply.trim()) {
      this.apiService.openErrorSnackBar('Reply field is required.');
      return;
    }

    const thread = this.oilEventItemsThreadsList.find((t) => t.reply);

    this.isSaving = true;
    try {
      // if create for status list
      let data = {
        itemId: Number(this.item?.id),
        body: this.reply,
        threadId: thread.threadId ? thread.threadId : thread.id,
        parentId: thread.id,
        mentions: mentions.map((mention) => mention.id),
      };
      const formData = new FormData();
      formData.append('recordObj', JSON.stringify(data));
      if (this.replyAttachments?.length > 0) {
        this.replyAttachments.forEach((res) => {
          formData.append('attachments[]', res?.file);
        });
      }
      (this.sub = this.apiService.addEventItemsComment(formData).subscribe(
        (res: any) => {
          if (res !== null) {
            // this.apiService.openSnackBar('Data Created Successfully');
            this.isSaving = false;
            this.reply = '';
            this.getEventItemsThread();
            const mentionEl = document.getElementById('replyMentionElement');
            if (mentionEl) {
              mentionEl.innerHTML = ''; // resets value to empty (null-like)
            }
            this.oilEventItemsThreadsList = this.oilEventItemsThreadsList.map(t => ({
              ...t,
              reply: false,
              edit: false
            }));
          }
          this.replyAttachments = [];
          this.replyFileInput.nativeElement.value = '';
        },
        (err: any) => {
          this.isSaving = false;
          this.replyAttachments = [];
          this.replyFileInput.nativeElement.value = '';
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      )),
        (err: any) => {
          this.isSaving = false;
          this.replyAttachments = [];
          this.replyFileInput.nativeElement.value = '';
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }

  public closeModal(): void {
    this.modalController.dismiss({
      dismissed: true,
    });
  }

  public submitComment(): void {
    const { text, mentions } = this.extractMentionData('mentionElement');

    this.comment = text;
    if (!this.comment || !this.comment.trim()) {
      this.apiService.openErrorSnackBar('Comment field is required.');
      return;
    }

    this.isSaving = true;
    try {
      let data = {
        itemId: Number(this.item?.id),
        body: this.comment,
        mentions: mentions.map((mention) => mention.id),
      };
      const formData = new FormData();
      formData.append('recordObj', JSON.stringify(data));
      if (this.attachments?.length > 0) {
        this.attachments.forEach((res) => {
          formData.append('attachments[]', res?.file);
        });
      }
      (this.sub = this.apiService.addEventItemsComment(formData).subscribe(
        (res: any) => {
          if (res !== null) {
            // this.apiService.openSnackBar('Data Created Successfully');
            this.isSaving = false;
            this.comment = '';
            this.getEventItemsThread();
            const mentionEl = document.getElementById('mentionElement');
            if (mentionEl) {
              mentionEl.innerHTML = ''; // resets value to empty (null-like)
            }
          }
          this.attachments = [];
          this.fileInput.nativeElement.value = '';
        },
        (err: any) => {
          this.isSaving = false;
          this.attachments = [];
          this.fileInput.nativeElement.value = '';
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      )),
        (err: any) => {
          this.isSaving = false;
          this.attachments = [];
          this.fileInput.nativeElement.value = '';
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }

  //Delete this function
  public getEventItemsComment(): void {
    this.oilEventItemsCommentsList = [];
    let data = {
      itemId: this.item?.id,
    };
    (this.userSub = this.apiService.getoilEventComment(data).subscribe(
      (res: any) => {
        if (res != null) {
          this.oilEventItemsCommentsList = res ? res : [];
        }
      },
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      }
    )),
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      };
  }

  public getRootThreads(threads): Object[] {
    const rootThreads = threads.filter((thread) => thread.threadId === null && thread.parentId === null);
    return rootThreads;
  }

  public getThreadComments(thread): Object[] {
    const threadComments = this.oilEventItemsThreadsList.filter((t) => t.threadId === thread.threadId);
    return threadComments;
  }

  public getThreadParentComment(thread): string {
    const parent = this.oilEventItemsThreadsList.find(
      (t) => t.threadId === thread.threadId && t.parentId == thread.parentId
    );
    return parent.body;
  }



  private restoreEditableContent(threadId: number, text: string, type: 'reply' | 'edit') {
    setTimeout(() => {
      const el1 = document.getElementById('editMentionElementSingle' + threadId);
      const el2 = document.getElementById('editMentionElement' + threadId);
      const elId =
        type === 'reply'
          ? 'replyMentionElement'
          : el1 ? 'editMentionElementSingle' + threadId : 'editMentionElement' + threadId;

      const el = document.getElementById(elId);

      if (el && text) {
        el.innerHTML = text;
      }
    });
  }


  onEditTyping(thread) {
    const el = document.getElementById('editMentionElementSingle' + thread.id);
    const el2 = document.getElementById('editMentionElement' + thread.id);
    if (el) {
      this.tempEditText = el.innerHTML;
    }
    else if (el2) {
      this.tempEditText = el2.innerHTML;
    }
  }


  onReplyTyping() {
    const el = document.getElementById('replyMentionElement');
    if (el) {
      this.tempReplyText = el.innerHTML;
    }
  }





  public getEventItemsThread(): void {
    // this.oilEventItemsThreadsList = [];
    let data = {
      itemId: this.item?.id,
    };
    (this.userSub = this.apiService.getOilEventThreads(data).subscribe(
      (res: any) => {
        if (res != null) {
          this.oilEventItemsThreadsList = res ? this.flattenThread(res).map(t => {
            const oilEventItemThread = this.oilEventItemsThreadsList.find(i => i.id === t.id);
            if (t.id === this.openedThreadId) {
              t.open = true;
            }
            else {
              t.open = false;
            }
            t.reply = oilEventItemThread?.reply;
            t.edit = oilEventItemThread?.edit;

            if (oilEventItemThread?.reply && this.tempReplyText) {
              this.restoreEditableContent(t.id, this.tempReplyText, 'reply');
            }

            if (oilEventItemThread?.edit && this.tempEditText) {
              this.restoreEditableContent(t.id, this.tempEditText, 'edit');
            }


            return t;
          }) : [];
        }
      },
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      }
    )),
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      };
  }

  public getEventItemActivityLogs(): void {
    // this.oilEventItemActivityLogs = [];
    let data = {
      itemId: this.item?.id,
    };
    (this.userSub = this.apiService.getOilEventItemActivityLogs(data).subscribe(
      (res: any) => {
        if (res != null) {
          this.oilEventItemActivityLogs = res
            .map((r) => ({
              ...r,
              createdAt: new Date(r.createdAt).toLocaleString('en-GB', {
                day: '2-digit',
                month: 'short',
                year: 'numeric',
                hour: '2-digit',
                minute: '2-digit',
                hour12: false,
              }),
            }))
            .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1));
        }
      },
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      }
    )),
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      };
  }

  public getEventItemThreadsList(): void {
    // this.oilEventItemThreadsList = [];
    let data = {
      itemId: this.item?.id,
    };
    (this.userSub = this.apiService.getOilEventItemListThread(data).subscribe(
      (res: any) => {
        if (res != null) {
          this.oilEventItemThreadsList = res;
        }
      },
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      }
    )),
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      };
  }

  public getEventItemsAttachment(): void {
    let data = {
      itemId: this.item?.id,
    };
    (this.userSub = this.apiService.getOilEventItemAttachment(data).subscribe(
      (res: any) => {
        if (res != null) {
          this.savedAttachmentsLists = res;
          if (this.type === 'Edit' && this.savedAttachmentsLists?.length > 0) {
            this.apiService.logPageFormStep.next(2);
          }
        }
      },
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      }
    )),
      (err) => {
        this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
      };
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.addFiles(input.files);
      input.value = ''; // ✅ reset so user can select same file again
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer?.files) {
      this.addFiles(event.dataTransfer.files);
      event.dataTransfer.clearData();
    }
  }

  onReplyFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.addReplyFiles(input.files);
      input.value = ''; // ✅ reset so user can select same file again
    }
  }

  onReplyDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onReplyDrop(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer?.files) {
      this.addReplyFiles(event.dataTransfer.files);
      event.dataTransfer.clearData();
    }
  }

  removeReplyAttachment(index: number): void {
    this.attachments.splice(index, 1);
  }

  private addReplyFiles(files: FileList): void {
    Array.from(files).forEach((file) => {
      const alreadyAdded = this.replyAttachments.some(
        (att) => att.file.name === file.name && att.file.size === file.size
      );
      if (alreadyAdded) return; // Skip duplicates

      const isImage = file.type.startsWith('image/');
      const attachment: { file: File; preview?: string; isImage: boolean } = { file, isImage };

      if (isImage) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          attachment.preview = e.target.result;
          this.replyAttachments.push(attachment);
        };
        reader.readAsDataURL(file);
      } else {
        this.replyAttachments.push(attachment);
      }
      // Optional: Auto-upload each file to server
    });
  }

  private addFiles(files: FileList): void {
    Array.from(files).forEach((file) => {
      const alreadyAdded = this.attachments.some((att) => att.file.name === file.name && att.file.size === file.size);
      if (alreadyAdded) return; // Skip duplicates

      const isImage = file.type.startsWith('image/');
      const attachment: { file: File; preview?: string; isImage: boolean } = { file, isImage };

      if (isImage) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          attachment.preview = e.target.result;
          this.attachments.push(attachment);
        };
        reader.readAsDataURL(file);
      } else {
        this.attachments.push(attachment);
      }
      // Optional: Auto-upload each file to server
    });
  }

  removeAttachment(index: number): void {
    this.attachments.splice(index, 1);
  }

  public async downloadFile(fileName: string, url: string) {
    // we use this downloadFile(folder: string, fileName: string, fn: string,url:string) if we uncomment s3 code
    // const bucket = new S3({
    //   accessKeyId: environment.WSaccessKeyId,
    //   secretAccessKey: environment.WSsecretAccessKey,
    //   region: environment.WSregion,
    //   endpoint: environment.WSendpoint
    // });

    // const params = {
    //   Bucket: environment.WSBucket,
    //   Key: folder + '/' + this.assetSN.replace(' ', '-') + '/' + fileName
    // };

    // const handleError = (err) => {
    //   this.openSnackBar(err.message ? err.message : err);
    // };

    // const handleData = (err, data) => {
    //   if (err) {
    //     handleError(err);
    //     return;
    //   }

    // const binaryData = [];
    // binaryData.push(data.Body);
    // const objectData = new Blob(binaryData, { type: data.ContentType });

    // const file = new File([objectData], fn, {
    //   type: objectData.type,
    // });
    const fileExtension = url.split('.').pop()?.toLowerCase();
    if (fileExtension === 'pdf') {
      //file.name.toLowerCase().includes('pdf') for s3 code
      //code will be in no need if we uncomment above s3 code that start here
      const response = await fetch(url);
      if (!response.ok) {
        throw new Error(`Failed to fetch file: ${response.statusText}`);
      }

      const blob = await response.blob();
      const file = new File([blob], fileName, { type: blob.type });
      // end here
      const url1 = window.URL.createObjectURL(file);
      window.open(url1);
    } else if (['png', 'jpg', 'jpeg', 'gif', 'bmp', 'webp'].includes(fileExtension)) {
      // open a new tab with an HTML wrapper for better control
      const htmlContent = `
    <html>
      <head>
        <title>${fileName}</title>
        <style>
          body {
            margin: 0;
            background-color: #f9f9f9;
            display: flex;
            justify-content: center;
            align-items: center;
            height: 100vh;
          }
          img {
            max-width: 90vw;
            max-height: 90vh;
            object-fit: contain;
            border: 1px solid #ccc;
            box-shadow: 0 0 10px rgba(0,0,0,0.2);
          }
        </style>
      </head>
      <body>
        <img src="${url}" alt="Image preview" />
      </body>
    </html>
  `;

      const blob = new Blob([htmlContent], { type: 'text/html' });
      const htmlUrl = URL.createObjectURL(blob);
      window.open(htmlUrl);
    } else {
      this.fileViewService.loadDocument(url);
    }

    // else if (this.hasValidImageExtension(file.name)) {
    //   const link = document.createElement('a');
    //   const url = URL.createObjectURL(file);
    //   window.open(url)
    // }
    // else {
    //   const link = document.createElement('a');
    //   const url = URL.createObjectURL(file);
    //   link.href = url;
    //   link.download = file.name;
    //   document.body.appendChild(link);
    //   link.click();

    //   document.body.removeChild(link);
    //   window.URL.revokeObjectURL(url);
    //   this.openSnackBar("File Started to Download");
    //   }
    // };

    // bucket.getObject(params, handleData.bind(this)).on('httpDownloadProgress', (progress) => {
    //   // Optionally handle download progress here
    // });
  }

  // public updateThread(thread) {}

  // public replyThread(thread) {}

  // public editThread(thread) {}

  // public onOpenEventDeleteDialog(thread) {}

  public replyComment(thread) {
    this.oilEventItemsThreadsList = this.oilEventItemsThreadsList.map((t) => {
      if (t.id === thread.id) {
        return {
          ...t,
          reply: true,
          edit: false
        };
      }
      return {
        ...t,
        reply: false,
        edit: false
      };
    });
  }

  public editComment(thread) {
    this.oilEventItemsThreadsList = this.oilEventItemsThreadsList.map((t) => {
      if (t.id === thread.id) {
        return {
          ...t,
          edit: true,
          reply: false
        };
      }
      return {
        ...t,
        edit: false,
        reply: false
      };
    });
  }

  public updateSingleComment(thread) {
    const { text, mentions } = this.extractMentionData('editMentionElementSingle' + thread.id);

    this.updateCommentValue = text;
    const threadIndex = this.oilEventItemsThreadsList.findIndex((t) => t.id === thread.id);
    this.oilEventItemsThreadsList[threadIndex].edit = false;

    if (!this.updateCommentValue || !this.updateCommentValue.trim()) {
      this.apiService.openErrorSnackBar('comment field is required.');
      return;
    }

    this.isSaving = true;
    try {
      // if create for status list
      let data = {
        id: Number(thread?.id),
        body: this.updateCommentValue,
        mentions: mentions.map((mention) => mention.id),
      };
      const formData = new FormData();
      if (this.attachmentsForUpdateComment?.length > 0) {
        formData.append('itemId', this.item?.id);
        formData.append('commentId', thread?.id);
        this.attachmentsForUpdateComment.forEach((res) => {
          formData.append('attachments[]', res?.file);
        });

        (this.sub = this.apiService.addEventItemsCommentAttachment(formData).subscribe(
          (res: any) => {
            this.attachmentsForUpdateComment = [];
            if (this.fileInput2) {
              this.fileInput2.nativeElement.value = '';
            }
            const mentionEl = document.getElementById('editMentionElementSingle' + thread.id);
            if (mentionEl) {
              mentionEl.innerHTML = ''; // resets value to empty (null-like)
            }
          },
          (err: any) => {
            this.isSaving = false;
            this.attachmentsForUpdateComment = [];
            if (this.fileInput2) {
              this.fileInput2.nativeElement.value = '';
            }
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
            return;
          }
        )),
          (err: any) => {
            this.isSaving = false;
            this.attachmentsForUpdateComment = [];
            if (this.fileInput2) {
              this.fileInput2.nativeElement.value = '';
            }
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
            return;
          };
      }

      (this.sub = this.apiService.updateEventItemsComment(data).subscribe(
        (res: any) => {
          if (res !== null) {
            // this.apiService.openSnackBar('Data update Successfully');
            this.getEventItemsThread();
            this.isSaving = false;
            this.comment = '';
          }
          this.attachmentsForUpdateComment = [];
          if (this.fileInput2) {
            this.fileInput2.nativeElement.value = '';
          }
        },
        (err: any) => {
          this.isSaving = false;
          this.attachmentsForUpdateComment = [];
          if (this.fileInput2) {
            this.fileInput2.nativeElement.value = '';
          }
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      )),
        (err: any) => {
          this.isSaving = false;
          this.attachmentsForUpdateComment = [];
          if (this.fileInput2) {
            this.fileInput2.nativeElement.value = '';
          }
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }

  public updateComment(thread) {
    const { text, mentions } = this.extractMentionData('editMentionElement' + thread.id);

    this.updateCommentValue = text;
    const threadIndex = this.oilEventItemsThreadsList.findIndex((t) => t.id === thread.id);
    this.oilEventItemsThreadsList[threadIndex].edit = false;

    if (!this.updateCommentValue || !this.updateCommentValue.trim()) {
      this.apiService.openErrorSnackBar('comment field is required.');
      return;
    }

    this.isSaving = true;
    try {
      // if create for status list
      let data = {
        id: Number(thread?.id),
        body: this.updateCommentValue,
        mentions: mentions.map((mention) => mention.id),
      };
      const formData = new FormData();
      if (this.attachmentsForUpdateComment?.length > 0) {
        formData.append('itemId', this.item?.id);
        formData.append('commentId', thread?.id);
        this.attachmentsForUpdateComment.forEach((res) => {
          formData.append('attachments[]', res?.file);
        });

        (this.sub = this.apiService.addEventItemsCommentAttachment(formData).subscribe(
          (res: any) => {
            this.attachmentsForUpdateComment = [];
            if (this.fileInput2) {
              this.fileInput2.nativeElement.value = '';
            }
            const mentionEl = document.getElementById('editMentionElement' + thread.id);
            if (mentionEl) {
              mentionEl.innerHTML = ''; // resets value to empty (null-like)
            }
          },
          (err: any) => {
            this.isSaving = false;
            this.attachmentsForUpdateComment = [];
            if (this.fileInput2) {
              this.fileInput2.nativeElement.value = '';
            }
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
            return;
          }
        )),
          (err: any) => {
            this.isSaving = false;
            this.attachmentsForUpdateComment = [];
            if (this.fileInput2) {
              this.fileInput2.nativeElement.value = '';
            }
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
            return;
          };
      }

      (this.sub = this.apiService.updateEventItemsComment(data).subscribe(
        (res: any) => {
          if (res !== null) {
            // this.apiService.openSnackBar('Data update Successfully');
            this.getEventItemsThread();
            this.isSaving = false;
            this.comment = '';
          }
          this.attachmentsForUpdateComment = [];
          if (this.fileInput2) {
            this.fileInput2.nativeElement.value = '';
          }
        },
        (err: any) => {
          this.isSaving = false;
          this.attachmentsForUpdateComment = [];
          if (this.fileInput2) {
            this.fileInput2.nativeElement.value = '';
          }
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      )),
        (err: any) => {
          this.isSaving = false;
          this.attachmentsForUpdateComment = [];
          if (this.fileInput2) {
            this.fileInput2.nativeElement.value = '';
          }
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }
  public eventDialogObj;
  public onOpenEventDeleteDialog = function (obj: any): void {
    this.selectedEventItemsCommentObj = obj;
    this.eventDialogObj = DialogUtility.confirm({
      title: 'Delete Confirmation',
      content: "Delete selected Event Item's Comment?",
      okButton: { text: 'OK', click: this.deleteEvent.bind(this) },
      cancelButton: { text: 'Cancel', click: this.cancelEventClick.bind(this) },
      showCloseIcon: true,
      closeOnEscape: true,
      animationSettings: { effect: 'Zoom' },
    });
  };

  private deleteEvent(): void {
    this.awdbSub = this.apiService.deleteEventItemsComment(this.selectedEventItemsCommentObj?.id).subscribe((data1) => {
      this.getEventItemsThread();
      this.eventDialogObj.hide();
    });
  }

  private cancelEventClick(): void {
    //Hide the dialog
    this.eventDialogObj.hide();
  }
  public oilEventItemsDialogObj;
  public onOpenOilEventItemAttachmentDeleteDialog = function (obj): void {
    this.oilEventItemAttachmentListObj = obj;
    this.oilEventItemsDialogObj = DialogUtility.confirm({
      title: 'Delete Confirmation',
      content: 'Delete selected attachment?',
      okButton: { text: 'OK', click: this.deleteOilEventItemAttachment.bind(this) },
      cancelButton: { text: 'Cancel', click: this.cancelOilEventItemAttachmentClick.bind(this) },
      showCloseIcon: true,
      closeOnEscape: true,
      animationSettings: { effect: 'Zoom' },
    });
  };

  private deleteOilEventItemAttachment(): void {
    try {
      (this.awdbSub = this.apiService
        .removeOilEventattachment({ id: this.oilEventItemAttachmentListObj?.id })
        .subscribe(
          (data1) => {
            this.getEventItemsAttachment();
            this.getEventItemsThread();
            this.oilEventItemsDialogObj.hide();
          },
          (err) => {
            this.apiService.openErrorSnackBar(
              err?.error?.error ? err?.error?.error : 'Please contact support team',
              null
            );
          }
        )),
        (err) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }

  private cancelOilEventItemAttachmentClick(): void {
    //Hide the dialog
    this.oilEventItemsDialogObj.hide();
  }

  onFileSelectedForCommentUpdate(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (input.files) {
      this.addFilesForCommentUpdate(input.files);
      input.value = ''; // ✅ reset so user can select same file again
    }
  }

  onDragOverForCommentUpdate(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
  }

  onDropForCommentUpdate(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();

    if (event.dataTransfer?.files) {
      this.addFilesForCommentUpdate(event.dataTransfer.files);
      event.dataTransfer.clearData();
    }
  }

  private addFilesForCommentUpdate(files: FileList): void {
    Array.from(files).forEach((file) => {
      const alreadyAdded = this.attachmentsForUpdateComment.some(
        (att) => att.file.name === file.name && att.file.size === file.size
      );
      if (alreadyAdded) return; // Skip duplicates

      const isImage = file.type.startsWith('image/');
      const attachment: { file: File; preview?: string; isImage: boolean } = { file, isImage };

      if (isImage) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          attachment.preview = e.target.result;
          this.attachmentsForUpdateComment.push(attachment);
        };
        reader.readAsDataURL(file);
      } else {
        this.attachmentsForUpdateComment.push(attachment);
      }
      // Optional: Auto-upload each file to server
    });
  }

  removeAttachmentForCommentUpdate(index: number): void {
    this.attachmentsForUpdateComment.splice(index, 1);
  }

  public getPhysicalInstpectionData(): void {
    this.physicalInspectionList = [];
    try {
      (this.awdbSub = this.apiService.getPhysicalInpection().subscribe(
        (res: any) => {
          this.physicalInspectionList = res?.data?.length > 0 ? res?.data : [];
        },
        (err) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      )),
        (err) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        };
    } catch (err) {
      this.apiService.openErrorSnackBar(err?.error?.error ? err?.error?.error : 'Please contact support team', null);
    }
  }
  // assignedUserDisabled(id: any): boolean {
  //   return this.item?.users?.some((ua: any) => ua?.userId === id) ?? false;
  // }

  scrollToComment(id: number | string) {
    const rootThread = this.oilEventItemsThreadsList.find((t) => t.id === id);
    this.oilEventItemsThreadsList = this.oilEventItemsThreadsList.map((t) => {
      if ((rootThread.thread && t.id === rootThread.thread) || (!rootThread.thread && t.id === rootThread.id)) {
        t.open = true;
      } else {
        t.open = false;
      }
      return t;
    });
    setTimeout(() => {
      const comment = this.oilEventItemsThreadsList
        .filter((thread) => thread.threadId === id || thread.id === id)
        .sort((a, b) => (a.createdAt > b.createdAt ? -1 : 1))[0];
      const container = this.commentsContainer.nativeElement;
      const target = document.getElementById(comment.id.toString());

      if (!container || !target) return;

      const offset = target.offsetTop - container.offsetTop;

      container.scrollTo({
        top: offset,
        behavior: 'smooth',
      });

      let data = {
        commentId: id,
      };
      this.apiService.markOilEventItemCommentAsSeen(data).subscribe(
        (res: any) => {
          if (res !== null) {
            // this.apiService.openSnackBar('Comment marked as seen!');
            this.getEventItemThreadsList();
          }
        },
        (err: any) => {
          this.apiService.openErrorSnackBar(
            err?.error?.error ? err?.error?.error : 'Please contact support team',
            null
          );
        }
      );
    }, 1);
  }
  convertToDate(dateStr: string): Date | null {
    if (!dateStr) return null;

    // Convert "2025-11-26 15:51:50" → "2025-11-26T15:51:50"
    const iso = dateStr.replace(' ', 'T');

    const date = new Date(iso);
    return isNaN(date.getTime()) ? null : date;
  }

  getPrimaryValue(row: any): string {
    switch (this.taskListType) {
      case 'AD':
        return row?.faaAdNum || null;
      case 'MPD':
        return row?.oemTaskNumber || null;
      case 'SBMOD':
        return row?.mod_sb_stc_fcd_si || null;
      default:
        return row?.mappingNumber || null;
    }
  }

  getSecondaryValue(row: any): string {
    switch (this.taskListType) {
      case 'AD':
        return row?.easaAdNum || null;
      case 'MPD':
        return row?.operatorTaskNumber || null;
      case 'SBMOD':
        return row?.eoEaTi || null;
      default:
        return row?.repairNumber || null;
    }
  }

  getPrimaryLabel(): string {
    switch (this.taskListType) {
      case 'AD':
        return 'FAA AD';
      case 'MPD':
        return 'OEM TASK NUMBER';
      case 'SBMOD':
        return 'MOD/SB/STC/FCD/SI';
      default:
        return 'MAPPING NUMBER';
    }
  }

  getSecondaryLabel(): string {
    switch (this.taskListType) {
      case 'AD':
        return 'EASA AD';
      case 'MPD':
        return 'OPERATOR TASK NUMBER';
      case 'SBMOD':
        return 'EO/EA/TI';
      default:
        return 'REPAIR NUMBER (IF NOT LISTED ON MAPPING)';
    }
  }
  displayFnForTaskList = (id: number): string => {
    const item = this.assetDocLists?.find((p) => p.assetMaintenanceMappingId === id);
    return item ? `${this.getPrimaryLabel()}: ${this.getPrimaryValue(item)} | ${this.getSecondaryLabel()}: ${this.getSecondaryValue(item)}` : '';
  };
  searchTaskListValue: any;
  onInputTaskListChange(event: any): void {
    this.searchTaskListValue = event?.target?.value?.toLowerCase()?.trim() || '';
  }
  getFilteredTaskList() {
    if (this.searchTaskListValue) {
      if (this.taskListId === null) {
        this.getData({ name: 'search', value: this.searchTaskListValue });
      }
    }
  }


  // Example API upload (adjust according to your backend)
}
